export default {
      id: "torso-usage",
      viewBox: "0 0 26 41",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#torso",
      toString: function () {
        return this.url;
      }
    }